// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v6.33.2
// source: api/devplan/types/user.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Timestamp } from "../../../google/protobuf/timestamp";
import { InfoSection } from "./common";

export const protobufPackage = "api.devplan.types.user";

export interface OnboardingState {
  completedSteps: string[];
  skippedSteps: string[];
  dismissed: boolean;
}

export interface UserPreferences {
  userId: string;
  ide?: IdePreferences | undefined;
  onboarding?: OnboardingState | undefined;
  roles?:
    | RolePreferences
    | undefined;
  /**
   * Free-form description of the user's work scope. Whitespace-only values
   * are treated as empty by personal digest eligibility.
   */
  scope?: string | undefined;
}

export interface IdePreferences {
  preferredIde?: string | undefined;
}

/**
 * RolePreferences captures which stakeholder roles this user wants
 * to see insights for. IDs are snake_case strings matching codeup's
 * role catalog (e.g. "product_manager", "sales").
 */
export interface RolePreferences {
  selectedRoleIds: string[];
}

/**
 * PersonalDigestContext is the global preference context used to determine
 * whether a workspace member should receive a personal digest.
 */
export interface PersonalDigestContext {
  userId: string;
  selectedRoleIds: string[];
  scope?: string | undefined;
}

export interface UserTrialInfo {
  ends?: Date | undefined;
  started: boolean;
  active: boolean;
  expired: boolean;
  skipTrialNotification: boolean;
}

export interface UserInfo {
  userId: string;
  infoSections: InfoSection[];
}

function createBaseOnboardingState(): OnboardingState {
  return { completedSteps: [], skippedSteps: [], dismissed: false };
}

export const OnboardingState: MessageFns<OnboardingState> = {
  encode(message: OnboardingState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.completedSteps) {
      writer.uint32(10).string(v!);
    }
    for (const v of message.skippedSteps) {
      writer.uint32(18).string(v!);
    }
    if (message.dismissed !== false) {
      writer.uint32(24).bool(message.dismissed);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OnboardingState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOnboardingState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.completedSteps.push(reader.string());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.skippedSteps.push(reader.string());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.dismissed = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OnboardingState {
    return {
      completedSteps: globalThis.Array.isArray(object?.completedSteps)
        ? object.completedSteps.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.completed_steps)
        ? object.completed_steps.map((e: any) => globalThis.String(e))
        : [],
      skippedSteps: globalThis.Array.isArray(object?.skippedSteps)
        ? object.skippedSteps.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.skipped_steps)
        ? object.skipped_steps.map((e: any) => globalThis.String(e))
        : [],
      dismissed: isSet(object.dismissed) ? globalThis.Boolean(object.dismissed) : false,
    };
  },

  toJSON(message: OnboardingState): unknown {
    const obj: any = {};
    if (message.completedSteps?.length) {
      obj.completedSteps = message.completedSteps;
    }
    if (message.skippedSteps?.length) {
      obj.skippedSteps = message.skippedSteps;
    }
    if (message.dismissed !== false) {
      obj.dismissed = message.dismissed;
    }
    return obj;
  },

  create(base?: DeepPartial<OnboardingState>): OnboardingState {
    return OnboardingState.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<OnboardingState>): OnboardingState {
    const message = createBaseOnboardingState();
    message.completedSteps = object.completedSteps?.map((e) => e) || [];
    message.skippedSteps = object.skippedSteps?.map((e) => e) || [];
    message.dismissed = object.dismissed ?? false;
    return message;
  },
};

function createBaseUserPreferences(): UserPreferences {
  return { userId: "", ide: undefined, onboarding: undefined, roles: undefined, scope: undefined };
}

export const UserPreferences: MessageFns<UserPreferences> = {
  encode(message: UserPreferences, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.userId !== "") {
      writer.uint32(10).string(message.userId);
    }
    if (message.ide !== undefined) {
      IdePreferences.encode(message.ide, writer.uint32(18).fork()).join();
    }
    if (message.onboarding !== undefined) {
      OnboardingState.encode(message.onboarding, writer.uint32(26).fork()).join();
    }
    if (message.roles !== undefined) {
      RolePreferences.encode(message.roles, writer.uint32(34).fork()).join();
    }
    if (message.scope !== undefined) {
      writer.uint32(50).string(message.scope);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UserPreferences {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserPreferences();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.userId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ide = IdePreferences.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.onboarding = OnboardingState.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.roles = RolePreferences.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.scope = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserPreferences {
    return {
      userId: isSet(object.userId)
        ? globalThis.String(object.userId)
        : isSet(object.user_id)
        ? globalThis.String(object.user_id)
        : "",
      ide: isSet(object.ide) ? IdePreferences.fromJSON(object.ide) : undefined,
      onboarding: isSet(object.onboarding) ? OnboardingState.fromJSON(object.onboarding) : undefined,
      roles: isSet(object.roles) ? RolePreferences.fromJSON(object.roles) : undefined,
      scope: isSet(object.scope) ? globalThis.String(object.scope) : undefined,
    };
  },

  toJSON(message: UserPreferences): unknown {
    const obj: any = {};
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.ide !== undefined) {
      obj.ide = IdePreferences.toJSON(message.ide);
    }
    if (message.onboarding !== undefined) {
      obj.onboarding = OnboardingState.toJSON(message.onboarding);
    }
    if (message.roles !== undefined) {
      obj.roles = RolePreferences.toJSON(message.roles);
    }
    if (message.scope !== undefined) {
      obj.scope = message.scope;
    }
    return obj;
  },

  create(base?: DeepPartial<UserPreferences>): UserPreferences {
    return UserPreferences.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UserPreferences>): UserPreferences {
    const message = createBaseUserPreferences();
    message.userId = object.userId ?? "";
    message.ide = (object.ide !== undefined && object.ide !== null)
      ? IdePreferences.fromPartial(object.ide)
      : undefined;
    message.onboarding = (object.onboarding !== undefined && object.onboarding !== null)
      ? OnboardingState.fromPartial(object.onboarding)
      : undefined;
    message.roles = (object.roles !== undefined && object.roles !== null)
      ? RolePreferences.fromPartial(object.roles)
      : undefined;
    message.scope = object.scope ?? undefined;
    return message;
  },
};

function createBaseIdePreferences(): IdePreferences {
  return { preferredIde: undefined };
}

export const IdePreferences: MessageFns<IdePreferences> = {
  encode(message: IdePreferences, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.preferredIde !== undefined) {
      writer.uint32(10).string(message.preferredIde);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IdePreferences {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIdePreferences();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.preferredIde = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IdePreferences {
    return {
      preferredIde: isSet(object.preferredIde)
        ? globalThis.String(object.preferredIde)
        : isSet(object.preferred_ide)
        ? globalThis.String(object.preferred_ide)
        : undefined,
    };
  },

  toJSON(message: IdePreferences): unknown {
    const obj: any = {};
    if (message.preferredIde !== undefined) {
      obj.preferredIde = message.preferredIde;
    }
    return obj;
  },

  create(base?: DeepPartial<IdePreferences>): IdePreferences {
    return IdePreferences.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<IdePreferences>): IdePreferences {
    const message = createBaseIdePreferences();
    message.preferredIde = object.preferredIde ?? undefined;
    return message;
  },
};

function createBaseRolePreferences(): RolePreferences {
  return { selectedRoleIds: [] };
}

export const RolePreferences: MessageFns<RolePreferences> = {
  encode(message: RolePreferences, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.selectedRoleIds) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RolePreferences {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRolePreferences();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.selectedRoleIds.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RolePreferences {
    return {
      selectedRoleIds: globalThis.Array.isArray(object?.selectedRoleIds)
        ? object.selectedRoleIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.selected_role_ids)
        ? object.selected_role_ids.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: RolePreferences): unknown {
    const obj: any = {};
    if (message.selectedRoleIds?.length) {
      obj.selectedRoleIds = message.selectedRoleIds;
    }
    return obj;
  },

  create(base?: DeepPartial<RolePreferences>): RolePreferences {
    return RolePreferences.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RolePreferences>): RolePreferences {
    const message = createBaseRolePreferences();
    message.selectedRoleIds = object.selectedRoleIds?.map((e) => e) || [];
    return message;
  },
};

function createBasePersonalDigestContext(): PersonalDigestContext {
  return { userId: "", selectedRoleIds: [], scope: undefined };
}

export const PersonalDigestContext: MessageFns<PersonalDigestContext> = {
  encode(message: PersonalDigestContext, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.userId !== "") {
      writer.uint32(10).string(message.userId);
    }
    for (const v of message.selectedRoleIds) {
      writer.uint32(18).string(v!);
    }
    if (message.scope !== undefined) {
      writer.uint32(26).string(message.scope);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PersonalDigestContext {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePersonalDigestContext();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.userId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.selectedRoleIds.push(reader.string());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.scope = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PersonalDigestContext {
    return {
      userId: isSet(object.userId)
        ? globalThis.String(object.userId)
        : isSet(object.user_id)
        ? globalThis.String(object.user_id)
        : "",
      selectedRoleIds: globalThis.Array.isArray(object?.selectedRoleIds)
        ? object.selectedRoleIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.selected_role_ids)
        ? object.selected_role_ids.map((e: any) => globalThis.String(e))
        : [],
      scope: isSet(object.scope) ? globalThis.String(object.scope) : undefined,
    };
  },

  toJSON(message: PersonalDigestContext): unknown {
    const obj: any = {};
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.selectedRoleIds?.length) {
      obj.selectedRoleIds = message.selectedRoleIds;
    }
    if (message.scope !== undefined) {
      obj.scope = message.scope;
    }
    return obj;
  },

  create(base?: DeepPartial<PersonalDigestContext>): PersonalDigestContext {
    return PersonalDigestContext.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PersonalDigestContext>): PersonalDigestContext {
    const message = createBasePersonalDigestContext();
    message.userId = object.userId ?? "";
    message.selectedRoleIds = object.selectedRoleIds?.map((e) => e) || [];
    message.scope = object.scope ?? undefined;
    return message;
  },
};

function createBaseUserTrialInfo(): UserTrialInfo {
  return { ends: undefined, started: false, active: false, expired: false, skipTrialNotification: false };
}

export const UserTrialInfo: MessageFns<UserTrialInfo> = {
  encode(message: UserTrialInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ends !== undefined) {
      Timestamp.encode(toTimestamp(message.ends), writer.uint32(10).fork()).join();
    }
    if (message.started !== false) {
      writer.uint32(16).bool(message.started);
    }
    if (message.active !== false) {
      writer.uint32(24).bool(message.active);
    }
    if (message.expired !== false) {
      writer.uint32(32).bool(message.expired);
    }
    if (message.skipTrialNotification !== false) {
      writer.uint32(40).bool(message.skipTrialNotification);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UserTrialInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserTrialInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ends = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.started = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.active = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.expired = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.skipTrialNotification = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserTrialInfo {
    return {
      ends: isSet(object.ends) ? fromJsonTimestamp(object.ends) : undefined,
      started: isSet(object.started) ? globalThis.Boolean(object.started) : false,
      active: isSet(object.active) ? globalThis.Boolean(object.active) : false,
      expired: isSet(object.expired) ? globalThis.Boolean(object.expired) : false,
      skipTrialNotification: isSet(object.skipTrialNotification)
        ? globalThis.Boolean(object.skipTrialNotification)
        : false,
    };
  },

  toJSON(message: UserTrialInfo): unknown {
    const obj: any = {};
    if (message.ends !== undefined) {
      obj.ends = message.ends.toISOString();
    }
    if (message.started !== false) {
      obj.started = message.started;
    }
    if (message.active !== false) {
      obj.active = message.active;
    }
    if (message.expired !== false) {
      obj.expired = message.expired;
    }
    if (message.skipTrialNotification !== false) {
      obj.skipTrialNotification = message.skipTrialNotification;
    }
    return obj;
  },

  create(base?: DeepPartial<UserTrialInfo>): UserTrialInfo {
    return UserTrialInfo.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UserTrialInfo>): UserTrialInfo {
    const message = createBaseUserTrialInfo();
    message.ends = object.ends ?? undefined;
    message.started = object.started ?? false;
    message.active = object.active ?? false;
    message.expired = object.expired ?? false;
    message.skipTrialNotification = object.skipTrialNotification ?? false;
    return message;
  },
};

function createBaseUserInfo(): UserInfo {
  return { userId: "", infoSections: [] };
}

export const UserInfo: MessageFns<UserInfo> = {
  encode(message: UserInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.userId !== "") {
      writer.uint32(10).string(message.userId);
    }
    for (const v of message.infoSections) {
      InfoSection.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UserInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.userId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.infoSections.push(InfoSection.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserInfo {
    return {
      userId: isSet(object.userId)
        ? globalThis.String(object.userId)
        : isSet(object.user_id)
        ? globalThis.String(object.user_id)
        : "",
      infoSections: globalThis.Array.isArray(object?.infoSections)
        ? object.infoSections.map((e: any) => InfoSection.fromJSON(e))
        : globalThis.Array.isArray(object?.info_sections)
        ? object.info_sections.map((e: any) => InfoSection.fromJSON(e))
        : [],
    };
  },

  toJSON(message: UserInfo): unknown {
    const obj: any = {};
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.infoSections?.length) {
      obj.infoSections = message.infoSections.map((e) => InfoSection.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<UserInfo>): UserInfo {
    return UserInfo.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UserInfo>): UserInfo {
    const message = createBaseUserInfo();
    message.userId = object.userId ?? "";
    message.infoSections = object.infoSections?.map((e) => InfoSection.fromPartial(e)) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
